<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
var colorList = [
  {
    c1: "rgba(255, 174, 13, 0.4)",
    c2: "rgba(255, 174, 13, 0)",
    line: "rgba(255, 174, 13, 1)"
  },
  {
    c1: "rgba(13, 255, 169, 0.4)",
    c2: "rgba(13, 255, 169, 0)",
    line: "rgba(13, 255, 169, 1)"
  },
]
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chartRrightBottom",
    },
    id: {
      type: String,
      default: "chartRrightBottom",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
    unit: {
      type: String,
      default: "亩",
    }
  },
  data() {
    return {
      chart: null,
      options: {
        tooltip: {
          position: function (pos, params, dom, rect, size) {
              // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
              let obj = {top: 30};
              obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
              return obj;
          },
          trigger: "axis",
          borderColor: 'rgba(10, 69, 31, 0.8)',
          backgroundColor: 'rgba(10, 69, 31, 0.8)',
          textStyle: {
            color: "#ffffff"
          },
          axisPointer: {
            type: "cross",
            label: {
              color: '#ffffff',
              backgroundColor: "rgba(10, 69, 31, 0.8)",
            }
          },
          formatter(params) {
            let dom = '';
            params.map((v,i)=>{
              dom+= `
              <div style="margin: 0px 0 10px;line-height:1;display: flex;align-items: center;">
                  ${v.marker}
                  <span style="font-size:14px;color:#fff;font-weight:400;margin-left:2px">${v.seriesName || '--'}:</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#fff;font-weight:900">${v.value || '0'}${chartVm.unit || '台'}</span>
                  </div>
                </div>
              `
            });
            let topDom = params && params.length>0 ? `<div style="font-size:14px;color:#fff;font-weight:400;line-height:1;margin-bottom: 10px">${params[0].axisValueLabel}</div>`:''
            return `<div>${topDom}${dom}</div>`;
          }
        },
        legend: {
          show: true,
          orient: "vertical",
          x: "50%", // orient: "vertical", 图例位置，设置right发现图例和文字位置反了，设置一个数值就好了
          y: "-5",
          itemWidth: 20,
          textStyle: {
            color: "#62D9AD",
            fontSize: "12",
          },
        },
        grid: {
          right: "10px",
          left: "15%",
          top: "20%",
          bottom: '14%'
        },
        xAxis: {
          type: "category",
          axisLabel: {
            show: true,
            margin: 10,
            fontSize: 12,
            rotate: -45,
            textStyle: {
              color: '#ffffff' //X轴文字颜色
            }
          },

          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 1,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          data: [],
        },

        yAxis: {
          minInterval: 1,
          name: `单位(${this.unit || '亩'})`,
          type: "value",
          nameTextStyle: {
            color: "#62D9AD",
            fontSize: 12,
            align: 'right'
          },
          axisLabel: {
            interval: 0,
            color: "#ffffff",
            fontSize: 12,
            rotate: 30,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    chartVm = this;
    this.initChart();
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      this.options.yAxis.name = `单位(${this.unit || '亩'})`;
      let series = [];
      let regionList = [];
      if (this.chartData) {
        let years = Object.keys(this.chartData);
        for (
          let index = 0;
          index < years.length;
          index++
        ) {
          const year = years[index];
          const el = this.chartData[`${year}`]
          if(index == 0) regionList = el.map(v=>{return v.month+'月'})
          series.push({
            name: `${year}年农机平均作业量`,
            type: "line",
            symbolSize: 8,
            smooth: 0.2,
            itemStyle: {
              normal: {
                borderWidth: 1,
                borderColor: "#0DFFA9",
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1, //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: colorList[index].c1,
                    },
                    {
                      offset: 0.5,
                      color: colorList[index].c1,
                    },
                    {
                      offset: 1,
                      color: colorList[index].c2,
                    },
                  ]
                ),
              },
            },
            lineStyle: {
              cap: 'round',
              width: 1,
              color: colorList[index].line
            },
            data: el.map(v=>{return v.value}),
            areaStyle: {},
          });
        }

        this.options.xAxis.data = regionList;
        this.options.series = series;
        this.chart.setOption(this.options);

      }
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
